import { ChangeEvent, useEffect, useRef } from "react"

export default function CustomCheckbox({
    indeterminate,
    checked,
    handleChange,
    value,
}: {
    indeterminate?: boolean,
    checked: boolean,
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void,
    value?: string | number,
}) {
    const checkboxRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (checkboxRef.current && indeterminate !== undefined) {
            checkboxRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <label className="inline-flex items-center cursor-pointer">
            <input 
                type="checkbox"
                ref={checkboxRef}
                checked={checked}
                onChange={handleChange}
                value={value}
                className="peer cursor-pointer transition-colors relative appearance-none w-4 h-4 border rounded-sm bg-gray-100 text-white border-outline checked:bg-primary checked:border-primary indeterminate:bg-primary indeterminate:border-primary"
            />
            {/* Checkmark Icon */}
            <svg
                className="w-4 h-4 absolute text-white hidden peer-checked:block"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>

            {/* Indeterminate Dash Icon */}
            <svg
                className="w-4 h-4 absolute text-white hidden peer-indeterminate:block"
                fill="currentColor"
                viewBox="0 0 24 24"
            >
                <rect x="5" y="11" width="14" height="2" rx="1" />
            </svg>
        </label>
    )
}